<template>
    <div>
            <FormComponent :data="formData" title="新增供应商" canEdit="true" @submit="submit">

            </FormComponent>
    </div>
</template>

<script  setup>
import FormComponent from '@/components/FormComponent.vue';
import {useAddSupplier} from "@/use/supplier"
const {formData,submit}=useAddSupplier();
</script>

<style scoped lang="scss">
::v-deep .cell{
    text-align: center;
}
</style>
